export const levels = [
    {
        id: 1,
        name: 'Easy',
        numOfPairs: 6
    },
    {
        id: 2,
        name: 'Medium',
        numOfPairs: 12
    },
    {
        id: 3,
        name: 'Hard',
        numOfPairs: 24
    },
    {
        id: 4,
        name: 'Out of this World',
        numOfPairs: 48
    }
];

// https://github.com/FortAwesome/react-fontawesome
// https://fontawesome.com/icons?d=gallery&s=brands&m=free
// see for naming conventions
export const faIcons = [
    'Html5',
    'Css3',
    'Js',
    'React',
    'Vuejs',
    'Angular',
    'Microsoft',
    'Google',
    'Adobe',
    'Apple',
    'Codepen',
    'Firefox',
    'Docker',
    'Facebook',
    'Wordpress',
    'Symfony',
    'StackOverflow',
    'Github',
    'Gitlab',
    'Java',
    'Linux',
    'Npm',
    'Jenkins',
    'Opera',
    'RaspberryPi',
    'Suse',
    'Ubuntu',
    'Windows',
    'Yarn',
    'Laravel',
    'FreeCodeCamp',
    'Bitcoin',
    'Android',
    'Bitbucket',
    'Bootstrap',
    'Atlassian',
    'Contao',
    'Git',
    'Grunt',
    'Gulp',
    'InternetExplorer',
    'Sass',
    'Soundcloud',
    'Drupal',
    'Php',
    'NodeJs',
    'Amazon',
    'Aws'
];